import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { BrowserPlatformService } from 'src/@services/browser-platform.service';
import { CommonService } from 'src/@services/common.service';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { CommonPagesService } from '../../common-pages.service';
import {
  ActivityType,
  BrooklynBillStatus,
  BrooklynInvestmentStatus,
  PaybevInvestmentStatus,
  PaybevPaymentStatus,
  responseMessageStatus,
  ResponseStatus,
  TransactionsType,
} from '../../enum';
import { filterActivePrograms } from '../../program-dropdown-filter';
interface siteDetails {
  Name: string;
  Profile: string;
  NonAlcStatus: boolean;
  IsProgramPeriodVisible: boolean;
  IsTagVisible: boolean;
}
@Component({
  selector: 'app-managetransaction',
  templateUrl: './managetransaction.component.html',
  styleUrls: ['./managetransaction.component.scss'],
  standalone: false,
})
export class ManagetransactionComponent implements OnInit {
  //#region properties
  isVisibleTransactionModal: boolean = true;
  @Output() hideTransactionModal = new EventEmitter();
  @Input() transactionType: number;
  @Input() transactionId: string;
  @Input() transactionDetails: any;
  brooklynBillStatus = BrooklynBillStatus;
  brooklynInvestmentStatus = BrooklynInvestmentStatus;
  isVisibleEditCancelRequestModal: boolean = false;
  listOfPrograms: any[] = [];
  private allPrograms: any[] = [];
  listOfTags: any[] = [];
  isLoadingPrograms: boolean = false;
  enableDropdowns: boolean = false;
  showProgramDrawer: boolean = false;
  showTagsModal: boolean = false;
  isLoadingTags: boolean = false;
  canDeleteInvestmemnt: boolean = false;
  canDeletePayment: boolean = false;
  showInvoiceNumber: boolean = true;
  canAddTag: boolean = false;
  canEditProgramTag: boolean = false;
  @Input() isFromActivity: boolean = true;
  @Input() showCancelButton: boolean = false;
  @Input() startingBalanceData: any;
  selectedTag: any;
  selectedTagName: string;
  selectedProgram: any;
  selectedTagFirst: any;
  selectedProgramFirst: any;
  selectedTagGroupFirst: any
  siteId: string;
  isPaymentModal = 'invest';
  isCancelled: boolean = false;
  selectedTagGroup: string = '';
  selectedProgarmName: string = '';
  currentDefaultProgram: any;
  currentTransactionDetails: any;
  isUpdatingDetails: boolean = false;
  vendorQBDetails: any;
  paybevVendorDetails: any;
  activityTypeEnum = ActivityType;
  transactionTypeEnum = TransactionsType;
  brooklynInvestment: number = BrooklynInvestmentStatus.PendingApproval;
  selectedTagDebit: any;
  selectedProgramDebit: any;
  selectedTagGroupDebit: any;
  selectedTagNameDebit: string;
  selectedProgarmNameDebit: string;
  isVisibleDeleteModal: boolean = false;
  isDeleting: boolean = false;
  isFetchingDetails: boolean = false;
  subscription: Subscription[] = [];
  isLoadingQBOLink: boolean;
  isLoadingInvoicePdf: boolean = false;
  filetype: any;
  qboOriginalbillLink: any;
  siteDetails: siteDetails;
  isAssignedProgramInactive = false;
  //#endregion

  //constructor
  constructor(
    private _cpS: CommonPagesService,
    private _route: ActivatedRoute,
    public _cS: CommonService,
    private _iS: InnerPagesService,
    private _router: Router,
    private sanitizer: DomSanitizer,
    private browserPlatformService: BrowserPlatformService
  ) { }

  //#region functions
  ngOnInit(): void {
    this.isFetchingDetails = true;
    this.siteId = this._route.snapshot.paramMap.get('siteId');

    //load program periods of current site.
    this.subscription.push(
      this._cS.listOfTags.subscribe((res: any) => {
        if (res != null) {
          this.listOfTags = res;
        }
      }),
      this._cS.listOfProgramPeriods.subscribe((res: any) => {
        if (res != null) {
          this.allPrograms = this.normalizeProgramsList(res);
          if (!this.showProgramDrawer) {
            this.refreshProgramDropdown();
          } else {
            this.syncEditModeWithAssignedProgram();
          }
          const defaultProgram = this.allPrograms.find(
            (x: any) => x.isDefault
          );
          if (defaultProgram) {
            this.currentDefaultProgram = defaultProgram;
          }
        }
      }),
      this._cS.agencySiteDetails.subscribe((res: siteDetails) => {
        if (res) {
          this.siteDetails = res;
        }
      })
    );

    // get permission details of current user role of users
    this._cS.fetchDataAfterAutoLogin.subscribe(() => {
      this.canAddTag = this._iS.canAccessProgramsTags().canAddProgramTag;
      this.canEditProgramTag = this._iS.canAccessProgramsTags().canEditProgramTag;
      this.canDeleteInvestmemnt =
        this._iS.canAccessInvestments().canDeleteInvestment;
      this.canDeletePayment = this._iS.canAccessPayments().canDeletePayment;
      this._cS.programsListObserver.next('call');
      this.getTags();
    });
  }
  getTags() {
    this._iS.getTagsDropdownList(this.siteId).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfTags = response.result;
        if (this.transactionType == TransactionsType.Payment) {
          this.getPaymentDetails();
        } else if (this.transactionType == TransactionsType.Investment) {
          this.getInvestmentDetails();
        } else if (this.transactionType == TransactionsType.Expenses) {
          this.getExpenseDetails();
        } else if (this.transactionType == TransactionsType.InternalTransfer) {
          this.getInternalTransferDetails();
        } else if (this.transactionType == TransactionsType.Refunds) {
          this.getRefundDetails();
        } else if (this.transactionType == TransactionsType.Credits) {
          this.getCreditDetails();
        } else if (this.transactionType == TransactionsType.Deposits) {
          this.getDepositDetails();
        } else if (this.transactionType == TransactionsType.StartingBalance) {
          this.getStartingBalanceDetails();
        } else {
          this.isFetchingDetails = false;
        }
      } else {
        this.listOfTags = [];
        this.isFetchingDetails = false;
        // this._cS.isLoadingTags = false;
      }
    });
  }
  getStartingBalanceDetails() {
    this._cpS
      .GetStartingBalanceDetails(this.transactionId)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.currentTransactionDetails = response.result;
          if (this.currentTransactionDetails.programId) {
            this.selectedProgram = this.currentTransactionDetails.programId;
            this.refreshProgramDropdown();
            if (this.selectedProgram) {
              this.getProgramName(this.currentTransactionDetails.programId);
            }
          }
          this.isFetchingDetails = false;
        } else {
          this.isFetchingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  navigateToActivityPage() {
    this._router.navigate(['/paybev/' + this.siteId + '/activity-detailed'], {
      queryParams: {
        filterTransactionType:
          this.showCancelButton == false
            ? ActivityType.CompletedTransactions
            : this.transactionType == TransactionsType.Investment
              ? ActivityType.OutstandingInvoice
              : ActivityType.PendingPayment,
      },
    });
  }

  getInvestmentDetails() {
    this._cpS
      .getInvestmentById(this.transactionId)
      .subscribe((response: any) => {
        if (
          response.responseStatus == ResponseStatus.success &&
          response.result != null
        ) {
          this.currentTransactionDetails = response.result;
          this.currentTransactionDetails.status = this.getStatus(
            this.currentTransactionDetails
          );
          this.currentTransactionDetails.createdOn = moment
            .utc(this.currentTransactionDetails.createdOn)
            .toDate();
          if (
            this.currentTransactionDetails.paybevInvestmentStatus ==
            PaybevInvestmentStatus.CancellationUnderReview ||
            this.currentTransactionDetails.brooklynInvestmentStatus ==
            BrooklynInvestmentStatus.UnderReview ||
            this.currentTransactionDetails.underReviewInfo
              ?.isMarkedAsUnderReview
          )
            this.isCancelled = true;

          // if (this.currentTransactionDetails?.brooklynInvestmentStatus == 1) {
          //   this.showInvoiceNumber = false;
          // }
          if (
            this.currentTransactionDetails.brooklynInvestmentStatus < 9 &&
            this.currentTransactionDetails.brooklynInvestmentStatus != 7
          ) {
            this.showCancelButton = true;
          }
          this.selectedProgram = this.currentTransactionDetails.program?.id;
          this.refreshProgramDropdown();
          this.getProgramName(this.selectedProgram);
          this.isFetchingDetails = false;
        } else {
          this.isFetchingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }

  getPaymentDetails() {
    this._iS
      .getPaymentDetails(this.transactionId)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.currentTransactionDetails = response.result;
          this.currentTransactionDetails.createdOn = moment
            .utc(this.currentTransactionDetails.createdOn)
            .toDate();
          if (
            this.transactionType == this.transactionTypeEnum.Payment &&
            response.result != null
          )
            this.vendorQBDetails =
              this.currentTransactionDetails.vendorDetails?.quickBookVendorDetails;
          this.paybevVendorDetails = this.currentTransactionDetails.vendorDetails?.payBevVendorDetails;
          if (
            this.currentTransactionDetails.paybevPaymentStatus ==
            PaybevPaymentStatus.CancellationUnderReview ||
            this.currentTransactionDetails.brooklynBillStatus ==
            BrooklynBillStatus.UnderReview ||
            this.currentTransactionDetails.underReviewInfo
              ?.isMarkedAsUnderReview
          )
            this.isCancelled = true;
          this.selectedProgram = this.currentTransactionDetails.program?.id;
          this.refreshProgramDropdown();
          this.selectedTag = this.currentTransactionDetails.tag?.id;
          this.getProgramName(this.selectedProgram);
          this.checkTagGroupData(this.selectedTag);
          // this.currentTransactionDetails.createdOn = this.getLocalDate(
          //   this.currentTransactionDetails.createdOn
          // );

          this.currentTransactionDetails.status = this.getStatus(
            this.currentTransactionDetails
          );
          if (this.currentTransactionDetails.brooklynBillStatus < 3) {
            this.showCancelButton = true;
          }
          this.isFetchingDetails = false;
        } else {
          this.isFetchingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  getExpenseDetails() {
    this._cpS.getExpense(this.transactionId).subscribe((response: any) => {
      if (
        response.responseStatus == ResponseStatus.success &&
        response.result != null
      ) {
        this.currentTransactionDetails = response.result;
        this.vendorQBDetails =
          this.currentTransactionDetails.vendorDetails?.quickBookVendorDetails;
        this.selectedProgram = this.currentTransactionDetails.program?.id;
        this.refreshProgramDropdown();
        this.selectedTag = this.currentTransactionDetails.tag?.id;
        this.currentTransactionDetails['status'] = 'Completed';
        this.getProgramName(this.selectedProgram);
        this.checkTagGroupData(this.selectedTag);
        this.isFetchingDetails = false;
      } else {
        this.isFetchingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  getRefundDetails() {
    this._cpS.getRefund(this.transactionId).subscribe((response: any) => {
      if (
        response.responseStatus == ResponseStatus.success &&
        response.result != null
      ) {
        this.currentTransactionDetails = response.result;
        this.currentTransactionDetails['status'] = 'Completed';
        this.vendorQBDetails =
          this.currentTransactionDetails.vendorDetails?.quickBookVendorDetails;
        this.selectedProgram = this.currentTransactionDetails.program?.id;
        this.refreshProgramDropdown();
        this.selectedTag = this.currentTransactionDetails.tag?.id;
        this.getProgramName(this.selectedProgram);
        this.checkTagGroupData(this.selectedTag);
        this.isFetchingDetails = false;
      } else {
        this.isFetchingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  getCreditDetails() {
    this._cpS.getCredit(this.transactionId).subscribe((response: any) => {
      if (
        response.responseStatus == ResponseStatus.success &&
        response.result != null
      ) {
        this.currentTransactionDetails = response.result;
        this.currentTransactionDetails['status'] = 'Completed';
        this.selectedProgram = this.currentTransactionDetails.program?.id;
        this.refreshProgramDropdown();
        this.selectedTag = this.currentTransactionDetails.tag?.id;
        this.getProgramName(this.selectedProgram);
        this.checkTagGroupData(this.selectedTag);
        this.isFetchingDetails = false;
      } else {
        this.isFetchingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  getDepositDetails() {
    this._cpS.getDeposit(this.transactionId).subscribe((response: any) => {
      if (
        response.responseStatus == ResponseStatus.success &&
        response.result != null
      ) {
        this.currentTransactionDetails = response.result;
        this.currentTransactionDetails['status'] = 'Completed';
        this.vendorQBDetails =
          this.currentTransactionDetails.vendorDetails?.quickBookVendorDetails;
        this.selectedProgram = this.currentTransactionDetails.program?.id;
        this.refreshProgramDropdown();
        this.selectedTag = this.currentTransactionDetails.tag?.id;
        this.getProgramName(this.selectedProgram);
        this.checkTagGroupData(this.selectedTag);
        this.isFetchingDetails = false;
      } else {
        this.isFetchingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }

  getInternalTransferDetails() {
    this._cpS
      .getInternalTransfer(this.transactionId)
      .subscribe((response: any) => {
        if (
          response.responseStatus == ResponseStatus.success &&
          response.result != null
        ) {
          this.setDetailsToIT(response.result);
        } else {
          this.isFetchingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  setDetailsToIT(data: any) {
    this.currentTransactionDetails = data;
    if (this.transactionDetails.transactionsSubType == 2) {
      this.selectedProgram =
        this.currentTransactionDetails.debitEntry.program?.id;
      this.selectedTag = this.currentTransactionDetails.debitEntry.tag?.id;
    } else {
      this.selectedProgram =
        this.currentTransactionDetails.creditEntry.program?.id;
      this.selectedTag = this.currentTransactionDetails.creditEntry.tag?.id;
    }
    this.refreshProgramDropdown();
    if (this.selectedProgram) this.getProgramName(this.selectedProgram);
    if (this.selectedTag) this.checkTagGroupData(this.selectedTag);
    this.isFetchingDetails = false;
  }
  private refreshProgramDropdown(): void {
    this.listOfPrograms = filterActivePrograms(this.allPrograms);
    this.syncEditModeWithAssignedProgram();
  }

  /** Leave edit mode when the transaction's program period is inactive. */
  private syncEditModeWithAssignedProgram(): void {
    this.updateAssignedProgramState();
    if (this.isAssignedProgramInactive && this.enableDropdowns) {
      this.undoChanges();
    }
  }

  /** API payloads may use isVisible or IsVisible; keep a single boolean on each program. */
  private getProgramVisibility(program: {
    isVisible?: boolean;
    IsVisible?: boolean;
  } | null | undefined): boolean | undefined {
    if (program == null) {
      return undefined;
    }
    if (typeof program.isVisible === 'boolean') {
      return program.isVisible;
    }
    if (typeof program.IsVisible === 'boolean') {
      return program.IsVisible;
    }
    return undefined;
  }

  private normalizeProgram(program: any): any {
    const visible = this.getProgramVisibility(program);
    return visible === undefined ? program : { ...program, isVisible: visible };
  }

  private normalizeProgramsList(programs: any[]): any[] {
    return (programs ?? []).map((p) => this.normalizeProgram(p));
  }

  private applyProgramUpdateFromManage(data: any): void {
    if (!data?.id) {
      return;
    }
    const normalized = this.normalizeProgram(data);
    const allIndex = this.allPrograms.findIndex((x: any) => x.id === data.id);
    if (allIndex >= 0) {
      Object.assign(this.allPrograms[allIndex], normalized);
    } else {
      this.allPrograms.unshift(normalized);
    }
  }

  private updateAssignedProgramState(): void {
    if (!this.selectedProgram) {
      this.isAssignedProgramInactive = false;
      return;
    }
    const program = this.allPrograms.find(
      (p: { id?: string }) => p.id === this.selectedProgram
    );
    const visible = this.getProgramVisibility(program);
    this.isAssignedProgramInactive = visible === false;
  }

  getProgramName(event: any) {
    if (!event) {
      this.selectedProgarmName = '';
      return;
    }
    const program = this.allPrograms.find((x: any) => x.id == event);
    this.selectedProgarmName =
      program?.label ?? this.currentTransactionDetails?.program?.name ?? '';
  }
  getProgramNameDebit(event: any) {
    if (!event) {
      this.selectedProgarmNameDebit = '';
      return;
    }
    const program = this.allPrograms.find((x: any) => x.id == event);
    this.selectedProgarmNameDebit = program?.label ?? '';
  }
  showCancelRequestModal() {
    if (
      this.currentTransactionDetails?.brooklynBillStatus == 1 ||
      this.currentTransactionDetails?.brooklynInvestmentStatus == 1
    ) {
      this.isVisibleDeleteModal = true;
    } else {
      this.isVisibleEditCancelRequestModal = true;
    }
  }
  sendUnderReviewNotification: boolean = false;
  hideCancelPaymentModal(event: any) {
    this.isVisibleEditCancelRequestModal = false;
    if (event.transactionId) {
      this.sendUnderReviewNotification = true;
      this.isCancelled = true;
      if (event.transactionsType == this.transactionTypeEnum.Payment) {
        this.currentTransactionDetails.paybevPaymentStatus = 2;
      } else {
        this.currentTransactionDetails.paybevInvestmentStatus = 6;
      }

      if (event.isEdit) {
        this.currentTransactionDetails.underReviewInfo = {
          isMarkedAsUnderReview: true,
          reason: 'Edit Request By User',
          color: 'gray',
        };
      } else {
        this.currentTransactionDetails.underReviewInfo = {
          isMarkedAsUnderReview: true,
          reason: 'Cancel Request By User',
          color: 'gray',
        };
      }
      this.hideTransactionModal.emit({
        hide: true,
        data: this.currentTransactionDetails,
      });
    }
  }

  manageProgramPeriod() {
    this.showProgramDrawer = true;
  }
  manageTags() {
    this.showTagsModal = true;
  }
  handleCancelProgram() {
    this.showProgramDrawer = false;
    this.refreshProgramDropdown();
    this._cS.programsListObserver.next('call');
  }
  newAddedProgram(event: any) {
    if (!event.data) {
      return;
    }
    this.applyProgramUpdateFromManage(event.data);
    if (event.data.isDefault) {
      this.selectedProgram = event.data.id;
      this.selectedProgramDebit = event.data.id;
      this.allPrograms.forEach(
        (x: any) => (x.isDefault = x.id === event.data.id)
      );
    }
    this.refreshProgramDropdown();
    if (this.selectedProgram) {
      this.getProgramName(this.selectedProgram);
    }
  }

  addUpdateProgram(event: any) {
    this.applyProgramUpdateFromManage(event.data);
    this.refreshProgramDropdown();
    if (this.selectedProgram) {
      this.getProgramName(this.selectedProgram);
    }
  }

  checkTagGroupData(event: any) {
    if (event) {
      let selectedGroup: any;
      let findSelectedTag: any;
      this.listOfTags.forEach((element: any) => {
        element.Tags.forEach((tag: any) => {
          if (tag._id == event) {
            findSelectedTag = tag;
            selectedGroup = element;
          }
        });
      });
      this.selectedTagGroup = selectedGroup;
      this.selectedTagName = findSelectedTag?.Name;
    }
  }
  checkTagGroupDataDebit(event: any) {
    let selectedGroup: any;
    let findSelectedTag: any;
    this.listOfTags.forEach((element: any) => {
      element.Tags.forEach((tag: any) => {
        if (tag._id == event) {
          findSelectedTag = tag;
          selectedGroup = element;
        }
      });
    });
    this.selectedTagGroupDebit = selectedGroup;
    this.selectedTagNameDebit = findSelectedTag?.Name;
  }
  printTransaction() {
    this.browserPlatformService.printCurrentPage();
  }
  handleCancelTags() {
    this.showTagsModal = false;
  }
  handleCancel(data?: any) {
    this.isVisibleDeleteModal = false;
    if (data || this.sendUnderReviewNotification) {
      this.hideTransactionModal.emit({
        hide: this.isVisibleDeleteModal,
        data: this.currentTransactionDetails,
      });
    }
  }
  deleteTransaction() {
    this.isDeleting = true;
    if (this.currentTransactionDetails.brooklynBillStatus) {
      this._cpS
        .deletePayment(this.currentTransactionDetails.id)
        .subscribe((response: any) => {
          if (response.responseStatus == 1) {
            this.isVisibleDeleteModal = false;
            this.isDeleting = false;
            this.handleCancel('data');
            this._cS.displayMessage('success', response.message);
          } else {
            this._cS.displayMessage('error', response.message);
            this.isVisibleDeleteModal = false;
            this.isDeleting = false;
          }
        });
    } else if (this.currentTransactionDetails.brooklynInvestmentStatus) {
      const formData = new FormData();
      formData.set('InvestmentId', this.currentTransactionDetails.id);
      this._cpS.deleteInvestment(formData).subscribe((response: any) => {
        if (response.responseStatus == 1) {
          this.isVisibleDeleteModal = false;
          this.isDeleting = false;
          this._cS.displayMessage('success', response.message);
          this.handleCancel('data');
        } else {
          this._cS.displayMessage('error', response.message);
          this.isDeleting = false;
          this.isVisibleDeleteModal = false;
        }
      });
    }
  }
  manageTrDeatails() {
    if (this.isAssignedProgramInactive) {
      return;
    }
    this.enableDropdowns = true;
    this.selectedTagFirst = this.selectedTag;
    this.selectedTagGroupFirst = this.selectedTagGroup;
    this.selectedProgramFirst = this.selectedProgram;
  }
  saveTrDetails() {
    this.isUpdatingDetails = true;
    if (this.transactionType == TransactionsType.Payment) {
      this.updatePayment();
    } else if (this.transactionType == TransactionsType.Investment) {
      this.updateInvestment();
    } else if (this.transactionType == TransactionsType.Expenses) {
      this.updateExpense();
    } else if (this.transactionType == TransactionsType.InternalTransfer) {
      this.updateInternalTransfer();
    } else if (this.transactionType == TransactionsType.StartingBalance) {
      this.updateStartingBalance();
    } else if (this.transactionType == TransactionsType.Credits) {
      this.updateCredit();
    } else if (this.transactionType == TransactionsType.Refunds) {
      this.updateRefund();
    } else if (this.transactionType == TransactionsType.Deposits) {
      this.updateDeposit();
    }
  }
  updateStartingBalance() {
    const formData = new FormData();
    formData.set('TransId', this.currentTransactionDetails.transactionsId);
    formData.set('ProgramId', this.selectedProgram);
    this._cpS
      .UpdateProgramToStartingBalTransaction(formData)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isUpdatingDetails = false;
          this.enableDropdowns = false;
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
          this.isUpdatingDetails = false;
        }
      });
  }
  updateExpense() {
    const requestBody = {
      expenseId: this.currentTransactionDetails.id,
      program: {
        id: this.selectedProgram,
        name: this.selectedProgarmName,
      },
      tag: {
        id: this.selectedTag,
        name: this.selectedTagName,
        transcationids: this.currentTransactionDetails.tag?.count,
      },
      isNonAlc: this.currentTransactionDetails.isNonAlc,
    };
    this._cpS.updateExpense(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isUpdatingDetails = false;
        this.enableDropdowns = false;
        this.selectedProgram = response.result.program.id;
        this.refreshProgramDropdown();
        this.selectedTag = response.result.tag.id;
        this.getProgramName(this.selectedProgram);
        this.checkTagGroupData(this.selectedTag);
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
      } else {
        this.isUpdatingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  updateInternalTransfer() {
    const requestBody = {
      transferId: this.currentTransactionDetails.id,
      creditEntry: {
        program:
          Number(this.transactionDetails.transactionsSubType) == 1
            ? {
              id: this.selectedProgram,
              name: this.selectedProgarmName,
            }
            : this.currentTransactionDetails.creditEntry.program,
        tag:
          Number(this.transactionDetails.transactionsSubType) == 1
            ? {
              id: this.selectedTag,
              name: this.selectedTagName,
              transcationids: this.currentTransactionDetails.creditEntry.tag
                ? this.currentTransactionDetails.creditEntry.tag
                  .transcationids
                : null,
            }
            : this.currentTransactionDetails.creditEntry.tag,
        isNonAlc: this.currentTransactionDetails.creditEntry.isNonAlc,
      },
      debitEntry: {
        program:
          Number(this.transactionDetails.transactionsSubType) == 2
            ? {
              id: this.selectedProgram,
              name: this.selectedProgarmName,
            }
            : this.currentTransactionDetails.debitEntry.program,
        tag:
          Number(this.transactionDetails.transactionsSubType) == 2
            ? {
              id: this.selectedTag,
              name: this.selectedTagName,
              transcationids: this.currentTransactionDetails.debitEntry.tag
                ? this.currentTransactionDetails.debitEntry.tag.transcationids
                : null,
            }
            : this.currentTransactionDetails.debitEntry.tag,
        isNonAlc: this.currentTransactionDetails.debitEntry.isNonAlc,
      },
    };

    this._cpS.updateInternalTransfer(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isUpdatingDetails = false;
        this.enableDropdowns = false;
        this.setDetailsToIT(response.result);
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
      } else {
        this.isUpdatingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  updatePayment() {
    this.currentTransactionDetails.program = {
      id: this.selectedProgram,
      name: this.selectedProgarmName,
    };
    this.currentTransactionDetails.tag = {
      id: this.selectedTag,
      name: this.selectedTagName,
    };
    this._cpS
      .updatePaymentDetails(this.currentTransactionDetails)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isUpdatingDetails = false;
          this.enableDropdowns = false;
          this.selectedProgram = response.result.program.id;
          this.refreshProgramDropdown();
          this.selectedTag = response.result.tag.id;
          this.getProgramName(this.selectedProgram);
          this.checkTagGroupData(this.selectedTag);
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this.isUpdatingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  updateCredit() {
    this.currentTransactionDetails.program = {
      id: this.selectedProgram,
      name: this.selectedProgarmName,
    };
    this.currentTransactionDetails.tag = {
      id: this.selectedTag,
      name: this.selectedTagName,
    };
    const requestBody = {
      id: this.currentTransactionDetails.id,
      program: this.currentTransactionDetails.program,
      tag: this.currentTransactionDetails.tag,
      isNonAlc: this.currentTransactionDetails.isNonAlc,
    };
    this._cpS.updateCredit(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isUpdatingDetails = false;
        this.enableDropdowns = false;
        this.selectedProgram = response.result.program.id;
        this.refreshProgramDropdown();
        this.selectedTag = response.result.tag.id;
        this.getProgramName(this.selectedProgram);
        this.checkTagGroupData(this.selectedTag);
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
      } else {
        this.isUpdatingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  updateRefund() {
    this.currentTransactionDetails.program = {
      id: this.selectedProgram,
      name: this.selectedProgarmName,
    };
    this.currentTransactionDetails.tag = {
      id: this.selectedTag,
      name: this.selectedTagName,
    };
    this._cpS
      .updateRefund(this.currentTransactionDetails)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isUpdatingDetails = false;
          this.enableDropdowns = false;
          this.selectedProgram = response.result.program.id;
          this.refreshProgramDropdown();
          this.getProgramName(this.selectedProgram);
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this.isUpdatingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  updateDeposit() {
    this.currentTransactionDetails.program = {
      id: this.selectedProgram,
      name: this.selectedProgarmName,
    };
    this.currentTransactionDetails.tag = {
      id: this.selectedTag,
      name: this.selectedTagName,
    };
    this._cpS
      .updateDeposit(this.currentTransactionDetails)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isUpdatingDetails = false;
          this.enableDropdowns = false;
          this.selectedProgram = response.result.program.id;
          this.refreshProgramDropdown();
          this.selectedTag = response.result.tag.id;
          this.getProgramName(this.selectedProgram);
          this.checkTagGroupData(this.selectedTag);
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this.isUpdatingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  patchTagToForm(event: any) {
    this.showTagsModal = false;
    this._cS.tagsObserver.next('call');
    setTimeout(() => {
      const tagGroup = this.listOfTags.find((x: any) => x._id == event.newTag);
      const newCreatedTag = tagGroup.Tags[tagGroup.Tags.length - 1];
      this.selectedTagGroup = tagGroup;
      if (newCreatedTag) {
        this.selectedTag = this.selectedTagDebit = newCreatedTag._id;
      }
    }, 2000);
  }

  updateInvestment() {
    const requestBody = this.currentTransactionDetails;
    requestBody.program = {
      id: this.selectedProgram,
      name: this.selectedProgarmName,
    };
    this._cpS.SaveInvestment(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isUpdatingDetails = false;
        this.enableDropdowns = false;
        this.selectedProgram = response.result.program.id;
        this.refreshProgramDropdown();
        this.getProgramName(this.selectedProgram);
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
      } else {
        this.isUpdatingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  undoChanges() {
    this.enableDropdowns = false;
    this.selectedProgram = this.selectedProgramFirst;
    this.refreshProgramDropdown();
    this.selectedTag = this.selectedTagFirst;
    this.selectedTagGroup = this.selectedTagGroupFirst;
  }

  getStatus(data: any) {
    const activityStatus =
      this.transactionType == TransactionsType.Payment
        ? data.brooklynBillStatus
        : data.brooklynInvestmentStatus;
    let status: any;
    const arrayToSearch: any =
      this.transactionType == TransactionsType.Payment
        ? this._cS.paymentStatus
        : this._cS.investmentStatus;
    arrayToSearch.every((element: any) => {
      if (element.statusEnum == activityStatus) {
        status = element.statusText;
        return false;
      }
      return true;
    });
    return status;
  }
  openPublicInvoice(invoiceLink: any) {
    this.browserPlatformService.openInNewTab(invoiceLink);
  }
  /* Opens the single-invoice PDF served by the API, keyed by QuickBooks invoice id. */
  openInvoicePdf() {
    this.isLoadingInvoicePdf = true;
    this._cpS
      .getInvoicePdf(
        this.currentTransactionDetails.qboEntityId,
        this.currentTransactionDetails.investmentType
      )
      .subscribe({
        next: (blob: Blob) => {
          this.isLoadingInvoicePdf = false;
          const pdfUrl = this.browserPlatformService.createObjectUrl(blob);
          this.browserPlatformService.openInNewTab(pdfUrl);
        },
        error: () => {
          this.isLoadingInvoicePdf = false;
          this._cS.displayMessage('error', 'Unable to load the invoice PDF.');
        },
      });
  }
  getLocalDate(UTCdate: any) {
    return moment.utc(UTCdate).toDate();
  }
  // to remove error : Error: unsafe value used in a resource URL context
  getSafeUrl(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  fetchAttachmentURL(qboAttachmentId: any) {
    this.isLoadingQBOLink = true;
    if (qboAttachmentId != null && qboAttachmentId != 'null') {
      this._cpS
        .PreviewQBOAttachment(qboAttachmentId)
        .subscribe((response: any) => {
          if (response.responseStatus == 1) {
            this.qboOriginalbillLink = response.result.tempDownloadUri;
            this.filetype = response.result.contentType;
            if (this.filetype.includes('image')) {
              this.qboOriginalbillLink = this.getSafeUrl(
                response.result.tempDownloadUri
              );
            }

            this.browserPlatformService.openInNewTab(this.qboOriginalbillLink);
            this.isLoadingQBOLink = false;
          } else {
            this._cS.displayMessage('error', response.message);
            this.isLoadingQBOLink = false;
          }
        });
    }
  }
  ngOnDestroy(): void {
    this.subscription.map((s) => s.unsubscribe());
  }
  //#endregion
}
